// extracted by mini-css-extract-plugin
export var arc = "loader-module--arc--RH0fo";
export var container = "loader-module--container--aK13H";
export var tip = "loader-module--tip--9b8GT";